import MicroModal from 'micromodal';

function modalJobs() {

    MicroModal.init({
        openTrigger: 'data-micromodal-trigger',
        closeTrigger: 'data-micromodal-close',
        disableScroll: true,
        awaitOpenAnimation: false,
        awaitCloseAnimation: false,
        onShow: (modal) => {
        const container = modal.querySelector('.modal__container');
        if (container) {
            container.scrollTop = 0;
        }
    },
    });
}

export default modalJobs;